<template>
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\loginManual-1.png" alt="" /></div>
                <div>
                    <p>① 画面上部のメインメニューバーにあるログインアイコンをクリックすると、ログイン情報の入力画面が表示されます。</p>
                    <p>② テキスト入力ボックス「アカウント」、「パスワード」に情報を入力します。</p>
                    <p>③ 「ログイン」ボタンを押下し、システムにログインします。</p>
                    <p>※1.「ログインしたままにする」にチェックを入れたら、次回本サービスをご利用になるときは、前回に入力された「アカウント」、「パスワード」情報が保持され、毎回入力する手間が省けます。</p>
                    <p>※2.初めてログインする場合には、セキュリティ強化のため、必ずパスワードの変更を行ってください。</p>
                    <p>※3.複数デバイスで同時にログインすることができませんのでご注意ください。</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/login_manual.vue